import { IComponentContext } from "../../shell/types"
import { IOmniaCommand } from "../../types"
import { defineDirective } from "../../utils/angular"
import { isFunction, isUndefined } from "../../utils/utils"

export function createModuleHeader(): ng.IDirective {

    return defineDirective(ModuleHeaderCtrl, "shared/components/moduleHeader/moduleHeader.html", {
        icon: "=",
        name: "=",
        commands: "=",
        datacontext: "=",
        pinnable: "=",
        context: "="
    });

};

/** @internal */
export class ModuleHeaderCtrl {

    static $inject = ["$scope", "$uibModal"];

    constructor(private $scope: ng.IScope, private $uibModal) {

    }

    icon: string;
    name: string;
    private commands: IOmniaCommand[];
    private datacontext: any;
    private pinnable: boolean;
    private context: IComponentContext;

    getMainIconClass() {
        const { icon } = this
        return icon && (icon.indexOf(" ") >= 0)
            ? icon
            : "icon " + icon
    }

    getIconCssClass(command: IOmniaCommand) {
        const icon = command?.icon
        return icon && (icon.indexOf(" ") >= 0)
            ? icon
            : "icon icon-" + icon
    }

    get filteredCommands(): IOmniaCommand[] {
        if (!this.commands) return [];
        return this.commands.filter(this.checkPopup);
    }

    get foregroundCommands(): IOmniaCommand[] {
        if (isUndefined(this.commands)) return [];

        return this.commands.filter(this.not(this.checkPopup)).filter(this.foreground);
    }

    get dropdownCommands(): IOmniaCommand[] {
        if (isUndefined(this.commands)) return [];

        return this.commands.filter(this.not(this.checkPopup)).filter(this.not(this.foreground));
    }

    canExecute(command: any) {

        var handler = command.canExecute;
        if (!isFunction(handler)) return true;

        return handler.apply(command, [this.datacontext]);

    }

    execute(command: any) {

        if (!this.canExecute(command)) return;

        var handler = command.execute;

        if (isFunction(handler)) {
            handler.apply(command, [this.datacontext]);
        }

    }

    pin() {
        var handler = this.context.pin;

        if (isFunction(handler)) {
            handler.apply(this.context);
        }
    }

    checkPopup(command: any) {
        return command["popupTemplate"];
    }

    foreground(command: any) {
        return command.foreground === true;
    }

    not(func: any) {
        return item => (!func(item));
    }

    help() {
        this.$uibModal.open({
            template: "<omnia-help-dialog help-key=\"" + (isUndefined(this.context) ? "No id found for this screen." : this.context.directive) + "\"></omnia-help-dialog>"
        });
    }

    isFullWidth(): boolean {
        if (!this.context) return true;
        if (!this.context.width) return true;
        if (this.context.width == Number.POSITIVE_INFINITY) return true;
        return false;
    }

    getCommandsContainerStyle(): any {

        var style;

        if (this.context && this.context.width) {
            style = { width: this.context.width + "px" };
        }

        return style;

    }

}
